import { ArrowLeft, BadgeCheck, Camera, Mic, MoreVertical, Paperclip, Phone, Smile, Video } from "lucide-react";

// Fundo de conversa no tom do WhatsApp (bege com desenhos miúdos). Desenho
// próprio — não é a imagem do WhatsApp — só pra a prévia ter a cara do app.
const DESENHO = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" fill="none" stroke="#ddd5c8" stroke-width="1.1" stroke-linecap="round">
    <circle cx="20" cy="24" r="5"/><path d="M62 16l5 9h-10z" transform="rotate(12 62 20)"/><path d="M112 22c4-6 12-6 14 0"/>
    <rect x="138" y="52" width="11" height="8" rx="2" transform="rotate(-10 143 56)"/><path d="M34 76c3 3 7 3 10 0"/>
    <circle cx="96" cy="70" r="2.5"/><path d="M18 128l5-5 5 5"/><path d="M70 120h10M75 115v10"/>
    <path d="M118 126c2-5 10-5 12 0s-10 5-12 0z"/><path d="M150 104c-3 2-3 6 0 8"/><circle cx="52" cy="150" r="1.8"/>
  </svg>`,
);
const FUNDO = { backgroundColor: "#efeae2", backgroundImage: `url("data:image/svg+xml,${DESENHO}")` };

/**
 * Celular com a conversa do WhatsApp aberta: barra verde com o nome da loja,
 * fundo bege, selo "Hoje" e a barra de digitar embaixo. O conteúdo (balões)
 * vem como filho — a prévia da campanha e o editor do modelo usam o mesmo.
 */
export default function CelularWhatsApp({ nomeLoja, logo, children }) {
  const agora = new Date();
  const hora = `${String(agora.getHours()).padStart(2, "0")}:${String(agora.getMinutes()).padStart(2, "0")}`;
  const inicial = (nomeLoja || "L").trim()[0]?.toUpperCase() || "L";

  return (
    <div className="mx-auto w-full max-w-[340px] rounded-[2.4rem] border-[6px] border-neutral-800 bg-neutral-900 shadow-2xl overflow-hidden">
      <div className="flex h-[640px] flex-col">
        {/* barra de status */}
        <div className="flex items-center justify-between bg-[#00664f] px-5 pt-2 pb-1 text-[11px] font-medium text-white tabular-nums">
          <span>{hora}</span>
          <span className="flex items-center gap-1 opacity-90">
            <span className="inline-block h-2 w-3 rounded-[2px] border border-white/80" />
            <span className="inline-block h-2 w-1 rounded-[1px] bg-white/80" />
          </span>
        </div>

        {/* cabeçalho da conversa */}
        <div className="flex items-center gap-2 bg-[#008069] px-2 py-2 text-white">
          <ArrowLeft className="h-5 w-5 shrink-0" />
          {logo ? (
            <img src={logo} alt="" className="h-9 w-9 shrink-0 rounded-full bg-white object-cover" />
          ) : (
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white/25 text-sm font-semibold">{inicial}</span>
          )}
          <div className="min-w-0 flex-1 leading-tight">
            <p className="flex items-center gap-1 truncate text-[15px] font-semibold">
              <span className="truncate">{nomeLoja || "Sua loja"}</span>
              <BadgeCheck className="h-4 w-4 shrink-0 fill-[#25d366] text-[#008069]" />
            </p>
            <p className="text-[11px] opacity-80">Conta comercial</p>
          </div>
          <Video className="h-5 w-5 shrink-0" />
          <Phone className="h-[18px] w-[18px] shrink-0" />
          <MoreVertical className="h-5 w-5 shrink-0" />
        </div>

        {/* conversa */}
        <div className="flex-1 overflow-y-auto px-3 py-3" style={FUNDO}>
          <div className="mb-3 flex justify-center">
            <span className="rounded-lg bg-white/90 px-3 py-1 text-[11px] font-medium uppercase text-[#54656f] shadow-sm">Hoje</span>
          </div>
          {children}
        </div>

        {/* barra de digitar (decorativa) */}
        <div className="flex items-center gap-2 bg-[#efeae2] px-2 pb-3 pt-1">
          <div className="flex flex-1 items-center gap-2 rounded-full bg-white px-3 py-2 text-[#8696a0] shadow-sm">
            <Smile className="h-5 w-5 shrink-0" />
            <span className="flex-1 text-[14px]">Mensagem</span>
            <Paperclip className="h-5 w-5 shrink-0" />
            <Camera className="h-5 w-5 shrink-0" />
          </div>
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#00a884] text-white">
            <Mic className="h-5 w-5" />
          </span>
        </div>
      </div>
    </div>
  );
}
